import { MichelinOneStarIcon, MichelinThreeStarIcon, MichelinTwoStarIcon } from '@local/assets/icons'

import { MichelinGuide } from '@web/gql/graphql'

import styles from './PlaceAwards.module.scss'

export const getMichelinStarIcon = (michelinGuide?: MichelinGuide | null) => {
  if (!michelinGuide?.starCount) return null

  const MICHELIN_STAR_ICON = {
    '1': MichelinOneStarIcon,
    '2': MichelinTwoStarIcon,
    '3': MichelinThreeStarIcon,
  } as const

  const starCount = michelinGuide.starCount.toString() as keyof typeof MICHELIN_STAR_ICON

  return {
    Icon: MICHELIN_STAR_ICON[starCount],
    style: styles[`icon_star_${starCount}`],
  }
}
